import Text from "../text"
import { Container, Message } from "./styles"


interface IProps {
  texto: string,
  tamanhoFonte?: string
  textoSecundario?: string | null
  className?: string
}


const MensagemListaVazia: React.FC<IProps> = ({ texto, tamanhoFonte, textoSecundario, ...props }) => {
  return (
    <Container {...props}>
      <Text className="!text-[.875rem] !font-medium text-center">{texto}</Text>
      <img src="assets/empty.png" width={70} style={{ opacity: .6 }} />
      {textoSecundario && <Text className="!text-[.875rem] !font-light text-center">{textoSecundario}</Text>}
    </Container>
  )
}


export default MensagemListaVazia;